export function htmlHasEmptyContent(html: string): boolean {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const images = doc.getElementsByTagName('img');
    return doc.body.innerText.trim().length === 0 && images.length === 0;
}
